(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fx-main-product"]) return;
  try {
    
(function () {
  var pdp = document.querySelector('[data-fx-pdp]');
  if (!pdp) return;
  var json = document.getElementById('fx-product-json');
  var data; try { data = JSON.parse(json.textContent); } catch (e) { return; }
  var RE = /menge|anzahl|stück|stueck|set|quantity|pack/i;
  var qi = -1; (data.options || []).forEach(function (n, i) { if (RE.test(n)) qi = i; });
  var money = function (c) { return (window.FX && window.FX.money) ? window.FX.money(c) : (c / 100).toFixed(2).replace('.', ',') + ' €'; };
  var sel = function () { return data.options.map(function (n, i) { var c = pdp.querySelector('input[data-opt-index="' + i + '"]:checked'); return c ? c.value : null; }); };
  var find = function (s) { var m = null; data.variants.forEach(function (v) { if (v.options.every(function (o, i) { return o === s[i]; })) m = v; }); return m; };

  function bundles() {
    if (qi < 0) return;
    pdp.querySelectorAll('input[data-opt-index="' + qi + '"]').forEach(function (inp) {
      var s = sel(); s[qi] = inp.value;
      var v = find(s), lab = inp.nextElementSibling;
      if (!v || !lab) return;
      var n = parseInt(inp.value, 10) || 1, single = null;
      data.variants.forEach(function (x) {
        if (/^1\b/.test(x.options[qi]) && x.options.every(function (o, i) { return i === qi || o === v.options[i]; })) single = x;
      });
      var pct = lab.querySelector('[data-b-pct]'), per = lab.querySelector('[data-b-per]');
      var full = single ? single.price * n : 0;
      if (pct) {
        if (n > 1 && full > v.price) { pct.textContent = '−' + Math.round((1 - v.price / full) * 100) + ' %'; pct.hidden = false; }
        else pct.hidden = true;
      }
      if (per && n > 1) { per.textContent = 'nur ' + money(Math.round(v.price / n)) + ' / Stück'; per.hidden = false; }
    });
  }

  function eta() {
    var el = pdp.querySelector('[data-eta]'); if (!el) return;
    var out = el.querySelector('[data-eta-range]'); if (!out) return;
    var add = function (n) { var d = new Date(), c = 0; while (c < n) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) c++; } return d; };
    var f = function (d) { return d.toLocaleDateString('de-DE', { weekday: 'short', day: 'numeric', month: 'numeric' }); };
    var a = parseInt(el.dataset.min, 10), b = parseInt(el.dataset.max, 10);
    if (a > 0 && b >= a) out.textContent = f(add(a)) + ' – ' + f(add(b));
  }

  var run = function () { bundles(); eta(); };
  pdp.addEventListener('change', function () { setTimeout(bundles, 0); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(run, 0); });
  else setTimeout(run, 0);
  window.addEventListener('load', function () { setTimeout(bundles, 0); });
})();

  } catch(e) { console.error(e); }
})();
})();
